import { Language } from '@nxt-insurance/constants'

import { type TermLifeStepParams, successSchema } from '@flows/configs/de/termLife/steps/types'
import { CALENDLY_STAGING_LINK } from '@flows/configs/shared/mgaLight/constants'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

const getCalendlyLink = (params: TermLifeStepParams) => {
  if (params.environment === 'production') {
    return params.getCurrentLanguage() === Language.De
      ? 'https://calendly.com/getsafe-leben-gesundheit/lv-de'
      : 'https://calendly.com/getsafe-leben-gesundheit/lv-en'
  }

  return CALENDLY_STAGING_LINK
}

export const success = (params: TermLifeStepParams) => {
  return {
    schema: successSchema,
    stepContent: [
      {
        type: 'animation',
        width: 140,
        height: 140,
        source: require('@ui-kit/assets/animations/check.json') as string,
      },
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.title',
        },
        condition: {
          type: 'conditions',
          comparisonType: 'anyOf',
          conditions: [
            {
              type: 'value',
              valuePath: params.helperFunctions.getParamPath('employment'),
              equalityType: 'notEquals',
              expectedValue: 'student',
            },
            {
              type: 'value',
              value: params.getCurrentLanguage(),
              equalityType: 'notEquals',
              expectedValue: Language.En,
            },
          ],
        },
      },
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.title_alternate',
        },
        condition: {
          type: 'conditions',
          comparisonType: 'allOf',
          conditions: [
            {
              type: 'value',
              valuePath: params.helperFunctions.getParamPath('employment'),
              expectedValue: 'student',
            },
            {
              type: 'value',
              value: params.getCurrentLanguage(),
              expectedValue: Language.En,
            },
          ],
        },
      },
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.text',
        },
        condition: {
          type: 'conditions',
          comparisonType: 'anyOf',
          conditions: [
            {
              type: 'value',
              valuePath: params.helperFunctions.getParamPath('employment'),
              equalityType: 'notEquals',
              expectedValue: 'student',
            },
            {
              type: 'value',
              value: params.getCurrentLanguage(),
              equalityType: 'notEquals',
              expectedValue: Language.En,
            },
          ],
        },
      },
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.text_alternate',
        },
        condition: {
          type: 'conditions',
          comparisonType: 'allOf',
          conditions: [
            {
              type: 'value',
              valuePath: params.helperFunctions.getHelperPath('employment'),
              expectedValue: 'student',
            },
            {
              type: 'value',
              value: params.getCurrentLanguage(),
              expectedValue: Language.En,
            },
          ],
        },
      },
      {
        type: 'calendly',
        title: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.calendly.title',
        },
        subtitle: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.calendly.subtitle',
        },
        link: getCalendlyLink(params),
        bgColor: 'grey100',
        condition: {
          type: 'conditions',
          comparisonType: 'anyOf',
          conditions: [
            {
              type: 'value',
              valuePath: params.helperFunctions.getParamPath('employment'),
              equalityType: 'notEquals',
              expectedValue: 'student',
            },
            {
              type: 'value',
              value: params.getCurrentLanguage(),
              equalityType: 'notEquals',
              expectedValue: Language.En,
            },
          ],
        },
      },
    ],
    subFlow: SubFlow.Common,
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    hideBackButton: true,
    buttonLabel: {
      type: 'translatableText',
      translationKey: 'sharedFlows_termLife:steps.success.proceedButtonLabel',
    },
    footer: { hideFooter: true },
    nextStep: 'appointment_details',
  } as const satisfies AnyStepConfiguration
}
